import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import './Login.css';
import Iridescence from '../home/sections/Iridescence';

const orbMessages = [
  'Si eres cliente, publica tu solicitud y conecta con flotillas verificadas y servicios logísticos completos.',
  'Si eres proveedor logístico, publica tu capacidad y recibe reservas reales en minutos.',
  'Diseñado para empresas de transporte, almacenes, agentes aduanales y freight forwarders.'
];

function LoginForm({
  email,
  setEmail,
  password,
  setPassword,
  handleSignIn,
  error,
  handleGoogleSignIn,
  googleSignInPending,
}) {
  return (
    <form
      className="login-form"
      onSubmit={event => {
        event.preventDefault();
        handleSignIn();
      }}
      noValidate
    >
      {error ? (
        <div className="login-error" role="alert">
          {error}
        </div>
      ) : null}

      <button
        type="button"
        className="login-google-btn"
        onClick={handleGoogleSignIn}
        disabled={!handleGoogleSignIn || googleSignInPending}
      >
        <FcGoogle aria-hidden="true" />
        <span>{googleSignInPending ? 'Conectando con Google…' : 'Continuar con Google'}</span>
      </button>

      <div className="login-divider" role="separator" aria-label="O ingresa con tu correo">
        <span>o usa tu correo corporativo</span>
      </div>

      <div className="login-fields">
        <div className="login-field">
          <label className="login-field-label" htmlFor="login-email">
            Correo electrónico
          </label>
          <input
            id="login-email"
            type="email"
            placeholder="nombre@empresa.com"
            value={email}
            onChange={event => setEmail(event.target.value)}
            autoComplete="username"
            required
          />
        </div>

        <div className="login-field">
          <label className="login-field-label" htmlFor="login-password">
            Contraseña
          </label>
          <input
            id="login-password"
            type="password"
            placeholder="Ingresa tu contraseña"
            value={password}
            onChange={event => setPassword(event.target.value)}
            autoComplete="current-password"
            required
          />
        </div>
      </div>

      <div className="login-actions">
        <label className="login-remember">
          <input type="checkbox" />
          <span>Recuérdame</span>
        </label>
        <Link to="/forgot-password" className="login-forgot">
          ¿Olvidaste tu contraseña?
        </Link>
      </div>

      <button type="submit" className="login-submit-btn">
        Ingresar
      </button>

    </form>
  );
}

function LoginAside() {
  const [messageIndex, setMessageIndex] = useState(0);
  const [isMessageVisible, setIsMessageVisible] = useState(true);
  const cycleTimeoutRef = useRef(null);
  const hideTimeoutRef = useRef(null);

  useEffect(() => {
    const total = orbMessages.length;
    if (!total) return undefined;

    const schedule = () => {
      cycleTimeoutRef.current = window.setTimeout(() => {
        setIsMessageVisible(false);
        hideTimeoutRef.current = window.setTimeout(() => {
          setMessageIndex(prev => (prev + 1) % total);
          setIsMessageVisible(true);
          schedule();
        }, 220);
      }, 4000);
    };

    schedule();

    return () => {
      window.clearTimeout(cycleTimeoutRef.current);
      window.clearTimeout(hideTimeoutRef.current);
    };
  }, []);

  return (
    <aside className="login-aside" aria-label="Resumen de beneficios Flotte">
      <Iridescence
        className="login-iridescence"
        color={[0, 0.2, 0.5]}
        mouseReact={false}
        amplitude={0.08}
        speed={0.08}
        aria-hidden="true"
      />
      <div className="login-aside-content">
        <div className="login-aside-content-inner">
          <div className="login-aside-header">
            <h2>
              <span className="login-aside-title-line">FLOTTE</span>
              <span className="login-aside-title-subline">La conexión entre</span>
              <span className="login-aside-title-subline login-aside-title-subline--nowrap">
                Clientes y Proveedores Logísticos
              </span>
            </h2>
            <p className={`login-aside-message${isMessageVisible ? ' login-aside-message--visible' : ''}`}>
              {orbMessages[messageIndex]}
            </p>
          </div>

          <div className="login-aside-footer" role="note">
            <span>¿Aún no eres parte de Flotte?</span>
            <Link to="/register">Crea tu cuenta</Link>
          </div>
        </div>
      </div>
    </aside>
  );
}

export default function Login({
  email,
  setEmail,
  password,
  setPassword,
  handleSignIn,
  error,
  handleGoogleSignIn,
  googleSignInPending = false,
}) {
  return (
    <main className="login-page">
      <div className="login-container">
        <section className="login-card">
          <div className="login-card-inner">
            <header className="login-header">
              <h1>Iniciar sesión</h1>
            </header>

            <LoginForm
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleSignIn={handleSignIn}
              error={error}
              handleGoogleSignIn={handleGoogleSignIn}
              googleSignInPending={googleSignInPending}
            />
          </div>
        </section>

        <LoginAside />
      </div>
    </main>
  );
}
